import BasePreferences from '$/entities/lib/BasePreferences';
import { Preference }  from '$/entities/lib/BasePreferences';
import { Field }       from '$/entities/lib/JSONable';

export enum TenantEmailKeys {
	IntroEmail       = 'introEmail',
	CreditAlertEmail = 'creditAlertEmail',
}

/**
 * Tenant's email preferences. Keeps track of unsubscribes.
 */
export class TenantPreferences extends BasePreferences {

	/**
	 * if false, tenant does not receive any of the intro email (TenantInvitation and it's subclasses)
	 */
	@Field()
	emails: Partial<Record<TenantEmailKeys, Preference>> = {
		[TenantEmailKeys.IntroEmail]       : true,
		[TenantEmailKeys.CreditAlertEmail] : true,
	};

}
